import { Box } from "@mantine/core";
import styles from "./styles.module.scss";

export function DashboardHeader() {
  return (
    <Box className={styles.container}>
      <img src="/logo/default-logo.svg" alt="Vinci Logo" />
    </Box>
  );
}
